import { callAPIWhiteToken } from "../config/api";

const PATH_API = process.env.REACT_APP_API;

export async function postDataPages(data: any) {
    const url = `${PATH_API}/news/filtered`;
    return await callAPIWhiteToken({
        url,
        method: "POST",
        data: data
    });
}


export async function getDataDetail(slug: string) {
    const url = `${PATH_API}/news/detail/${slug}`;
    return await callAPIWhiteToken({
        url,
        method: "GET"
    });
}


